import { showConfirmDialog } from '@juvare/common-web-ui/DialogHelper';
import { Typography } from '@mui/material';
import React from 'react';
export function showRemoveAccountDialog(params) {
    showConfirmDialog({
        title: params.t('panels.accounts.removeAccount', { count: params.count }),
        content: (React.createElement(React.Fragment, null,
            React.createElement(Typography, null, params.t('panels.accounts.removeQuestion', { count: params.count })),
            params.currentUserSelected && React.createElement(Typography, null, params.t('panels.accounts.currentUserNotDeleted')))),
        confirmLabel: params.t('common.remove'),
        onConfirm: () => params.onConfirm(),
    });
}
